import { useTranslatedProductContent } from "@/hooks/useTranslatedProductContent";

interface ScienceInsideProps {
  handle: string;
  className?: string;
}

export function ScienceInside({ handle, className }: ScienceInsideProps) {
  const { scienceInside } = useTranslatedProductContent(handle);

  if (!scienceInside) return null;

  return (
    <section className={`mb-8 md:mb-10 ${className || ''}`}>
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-2">
        {scienceInside.title}
      </h2>
      <p className="text-sm md:text-base text-muted-foreground text-center mb-5 md:mb-7 max-w-2xl mx-auto">
        {scienceInside.subtitle}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {scienceInside.cards.map((card, idx) => (
          <div
            key={idx}
            className="p-5 md:p-6 bg-white/70 rounded-2xl border border-white/80 shadow-sm flex flex-col"
          >
            {/* Icon */}
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-3 md:mb-4 rounded-2xl bg-gradient-to-br from-secondary to-pink-200 flex items-center justify-center p-2">
              <img src={card.icon} alt="" className="w-10 h-10 object-contain" aria-hidden="true" />
            </div>

            {/* Title */}
            <h3 className="font-bold text-base md:text-lg text-center mb-1">
              {card.title}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground text-center mb-3 md:mb-4 italic">
              {card.subtitle}
            </p>

            {/* Points */}
            <ul className="space-y-2 flex-1">
              {card.points.map((point, pIdx) => (
                <li key={pIdx} className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0 mt-1.5" />
                  <span className="text-xs md:text-sm text-foreground/80 leading-relaxed">
                    {point}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom tagline */}
      <p className="text-xs md:text-sm text-muted-foreground text-center mt-4 md:mt-5 max-w-xl mx-auto italic">
        {scienceInside.tagline}
      </p>
    </section>
  );
}
